import React from 'react';
import { showNotification, withDataProvider } from 'react-admin';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from './ConfirmationModal';
import { sendCustomApiRequest } from '../dataProvider';

class PushForConsentAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
    };
    ({ dataProvider: this.dataProvider } = this.props);
  }

  pushForConsent(isDialogAccepted) {
    this.setState({ showDialog: false });
    if (isDialogAccepted) {
      return this.sendRequest()
        .then((response) => {
          if (response.data.publishNow) {
            this.props.showNotification('Requested for new consent was successfully sent. From now on end-users will see Consent Popup again.');
          } else {
            this.props.showNotification('Error ocurred during invalidating consents. Please contact with Support Team.', 'warning');
          }
        })
        .catch(pushingForConsentError => {
          console.error(pushingForConsentError);
        });
    }
  }

  sendRequest() {
    switch (this.props.solutionType) {
      case 'website':
        let payload = {
          invalidateConsents: true,
          publishNow: true,
        };
        return this.dataProvider.update('websites', {
          id: this.props.consentSolutionId,
          data: payload,
        });
      case 'ucs':
        return sendCustomApiRequest(`/ucs/push_for_consent/${this.props.consentSolutionId}`, {})
          .then(() => {
            this.props.onPushForConsent();
          });
    }
  }

  render() {
    return <div className={this.props.className}>
      <Button variant="contained" data-testid="push-for-consent-button" color="secondary"
        onClick={() => this.setState({ showDialog: true })}>Push for consent</Button>
      <ConfirmationModal
        open={this.state.showDialog}
        title="Are you sure you want to push for consent?"
        okText="Show consents"
        cancelText="CANCEL"
        onCancel={() => this.pushForConsent(false)}
        onOk={() => this.pushForConsent(true)}
      />
    </div>;
  }
}

PushForConsentAction.propTypes = {
  consentSolutionId: PropTypes.string.isRequired,
  solutionType: PropTypes.oneOf(['website', 'ucs']),
};

export default connect(null, { showNotification })(withDataProvider(PushForConsentAction));
